module.exports = __webpack_public_path__ + "static/img/reward-bg.5bc9a333.png";